import axios from "axios";
import toast from "react-hot-toast";

// const BASE_URL = "https://edwardvolkov.pythonanywhere.com/api/v1";

const BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:8000/api/v1";

// ✅ axios instance
const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// ✅ Request Interceptor (Token ekleme)
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Response Interceptor (401 handling + hata toast)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const message = error?.response?.data?.detail || "خطا در ارتباط با سرور";

    if (status === 401) {
      // AuthContext'e haber ver
      window.dispatchEvent(new Event("force-logout"));

      toast.error("ابتدا وارد حساب کاربری خود شوید.", {
        id: "session-expired",
      });
    } else {
      toast.error(message, { id: "api-error" });
    }

    return Promise.reject(error);
  }
);

// ================== ✅ Auth API ==================
export const AuthAPI = {
  register: (data) => api.post("/auth/otp/register/", data),
  verifyRegisterOTP: (data) => api.post("/auth/otp/register/verify/", data),
  loginPassword: (data) => api.post("/auth/login/", data),
  loginOTP: (data) => api.post("/auth/otp/login/", data),
  verifyLoginOTP: (data) => api.post("/auth/otp/login/verify/", data),
};

// ================== ✅ User API ==================
export const UserAPI = {
  getProfile: () => api.get("/profile/user/"),
};

// ================== ✅ Games API ==================
export const GamesAPI = {
  list: () => api.get("/games/"),
  detail: (slug) => api.get(`/games/${slug}/`),
};

// ================== ✅ Blog API ==================
export const BlogAPI = {
  list: () => api.get("/blog/posts/"),
  get: (slug) => api.get(`/blog/posts/${slug}/`),
};

// ================== ✅ Clans API ==================
export const ClansAPI = {
  current: () => api.get("/clans/current/"),
  create: (data) => api.post("/clans/create/", data),
  update: (data) => api.put("/clans/current/update/", data),
  invite: (data) => api.post("/clans/invite/", data),
  invitations: () => api.get("/clans/invitations/"),
  leave: () => api.post("/clans/leave/"),
  handleInvitation: (id, accept) =>
    api.post(`/clans/invitations/${id}/handle/`, { accept }),
  kick: (data) => api.post("/clans/kick/", data),
  delete: () => api.delete("/clans/delete/"),
  leaderAccess: (value) =>
    api.post("/clans/leader-access/", { clan_leader_room_access: value }),
};

// ================== ✅ Wallet API ==================
export const WalletAPI = {
  transactions: () => api.get(`/user/transactions/`),
  balance: () => api.get("/user/wallet/"),
};

export const getRoomsByCategory = async (categoryId) => {
  const res = await api.get(`/competitions/?category=${categoryId}`);
  return res.data;
};

export const RoomApi = {
  info: (id) => api.get(`/competitions/${id}/info/`),
  teams: (id) => api.get(`/competitions/${id}/teams/`),
  reserve: (seatId) => api.post(`/competitions/seats/${seatId}/reserve/`),
  clanMembers: (roomId) =>
    api.get(`/clans/reservation/${roomId}/list-members/`),
  teamReserve: (teamId, memberUsernames) =>
    api.post(`/clans/reservation/${teamId}/`, {
      member_usernames: memberUsernames,
    }),
};

export default api;




